


































import Vue from "vue";
import _ from "lodash";
import UploadMixin from "@/mixins/upload-mixin";
import { myPlanDetail, updateMyPlanAttachments } from "@/api/my";
import { StorageBusinessType, ApprovalStatus } from "@/scripts/enums";
import { Toast } from "vant";

export default Vue.extend({
    name: "MyPlanUpload",
    mixins: [UploadMixin],
    props: {
        planId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            previewOptions: { showIndex: false },
            uploading: true,
            approvalStatus: "",
            attachments: new Array(0)
        };
    },
    computed: {
        hasAttachments(): boolean {
            return !_.isEmpty(this.attachments);
        },
        canEditAttachments(): boolean {
            return this.approvalStatus === ApprovalStatus.PENDING || this.approvalStatus === ApprovalStatus.REJECTED;
        }
    },
    mounted() {
        this.reloadAttachments();
    },
    methods: {
        reloadAttachments() {
            myPlanDetail(this.planId)
                .then(resp => {
                    this.approvalStatus = _.get(resp, "data.data.approvalStatus");
                    this.attachments = _.map(_.get(resp, "data.data.attachments"), attachment => {
                        return {
                            code: attachment.code,
                            name: attachment.name,
                            images: _.compact(
                                _.map(attachment.resource, resource => {
                                    return resource.downloadUrl;
                                })
                            ),
                            fileList: _.compact(
                                _.map(attachment.resource, resource => {
                                    return resource.thumbnailUrl
                                        ? { isImage: true, key: resource.fileKey, url: resource.thumbnailUrl }
                                        : null;
                                })
                            )
                        };
                    });
                })
                .catch();
        },
        onBeforeRead() {
            return this.uploading;
        },
        onAfterRead(file, detail) {
            const attachment = _.find(this.attachments, ["code", detail.name]);
            attachment.fileList = [{ isImage: true, status: "uploading" }];
            (this as any).afterRead(
                file,
                {
                    businessType: StorageBusinessType.ENROLLMENT_USER,
                    prefixFileName: detail.name,
                    businessId: this.planId
                },
                (fileKey, downloadUrl, thumbnailUrl) => {
                    updateMyPlanAttachments(
                        this.planId,
                        _.map(this.attachments, attachment => {
                            if (attachment.code === detail.name) {
                                return {
                                    code: detail.name,
                                    files: [fileKey]
                                };
                            }
                            return {
                                code: attachment.code,
                                files: _.map(attachment.fileList, "key")
                            };
                        })
                    )
                        .then(() => {
                            Toast(this.$t("upload.uploadSuccess"));
                            attachment.fileList = [{ isImage: true, key: fileKey, url: thumbnailUrl }];
                            attachment.images = [downloadUrl];
                        })
                        .catch(() => {
                            Toast(this.$t("upload.uploadFailed"));
                        });
                },
                () => {
                    this.uploading = true;
                }
            );
        },
        onBeforeDelete() {
            return this.$dialog.confirm({
                message: this.$t("common.alert.delete_alert") as string
            });
        },
        onDeleteAttachment(file, detail) {
            const attachment = _.find(this.attachments, ["code", detail.name]);
            attachment.fileList = [];
            updateMyPlanAttachments(
                this.planId,
                _.map(this.attachments, attachment => {
                    return {
                        code: attachment.code,
                        files: _.map(attachment.fileList, "key")
                    };
                })
            )
                .then(() => {
                    Toast(this.$t("common.alert.deleteSuccess"));
                })
                .catch(() => {
                    Toast(this.$t("common.alert.deleteFailed"));
                });
        }
    }
});
